import React from 'react'

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

import FroalaEditor from 'react-froala-wysiwyg';

export default function HTMLEditor2(props) {
    // props
    const {
        defaultValue,
        getResult
    } = props

    // config
    const modalConfig = {
        placeholderText: 'Type something...',
        charCounterCount: true
    }

    return (
        <React.Fragment>
            <FroalaEditor
                config={modalConfig}

                model={defaultValue}
                onModelChange={getResult}
            />
        </React.Fragment>
    )
}
